import { render, staticRenderFns } from "./ResearchArticle.vue?vue&type=template&id=7677a33f&"
import script from "./ResearchArticle.vue?vue&type=script&lang=js&"
export * from "./ResearchArticle.vue?vue&type=script&lang=js&"
import style0 from "./ResearchArticle.vue?vue&type=style&index=0&id=7677a33f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports